const actions = {
  //- Sets the selected user
  setSelectedUser ({ commit }, user) {
    console.log('Userstore - setSelectedUser')

    //- Mutate store
    commit('SET_SEL_USER', user)
  },
  
  setInitiatorUser ({ commit }, user) {
    console.log('Userstore - setInitiatorUser')

    //- Mutate store
    commit('SET_INITIATOR_USER', user)
  },

  clearInitiatorUser({ commit }) {
    console.log('Userstore - clearInitiatorUser')

    //- Mutate store
    commit('CLEAR_INITIATOR_USER')
  }
}

export default actions
